import { API_DEMO_PRESENTATION_URL } from "../Utilities/Helper";
import { post } from "./AxiosService";

// Marks every marketing contact with this email address as unsubscribed. The
// API reports success whether or not the address matched a contact, so the
// visitor is never told who we do or don't hold.
export function unsubscribeFromMailingList(data) {
  return post(
    `${API_DEMO_PRESENTATION_URL}unsubscribe_marketing_contact`,
    data
  ).then((res) => res.data);
}

// Puts the address back on the list, for someone who unsubscribed and changed
// their mind. Same non-disclosure behaviour as unsubscribing.
export function resubscribeToMailingList(data) {
  return post(
    `${API_DEMO_PRESENTATION_URL}resubscribe_marketing_contact`,
    data
  ).then((res) => res.data);
}
